import { SIGN_IN_PATH, route, SIGNUP_CHOICE_PATH, SIGNUP_PATH } from '../../steps/steps';

export const isLoginOrSignup = (pathname: string): boolean =>
  [route(SIGN_IN_PATH), route(SIGNUP_CHOICE_PATH), route(SIGNUP_PATH)].includes(pathname);
